var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxCat1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.139,
    height: 34.09,
    viewBox: "0 0 31.139 34.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_60814",
    "data-name": "Group 60814",
    transform: "translate(24079.898 -13565.91)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "product",
    d: "M61.6,39.165v2.782a.208.208,0,0,0,.111.186l2.256,1.257A.222.222,0,0,0,64.3,43.2V39.489L73.612,34.3l2.935,1.635a.694.694,0,0,1,.37.619v9.551a.694.694,0,0,1-.37.619L67.977,51.5a.746.746,0,0,1-.741,0l-8.571-4.775a.694.694,0,0,1-.37-.619V37.463l2.645,1.473A1.985,1.985,0,0,0,61.6,39.165Zm.672-21.557a.746.746,0,0,0-.741,0l-8.571,4.775a.694.694,0,0,0-.37.619v9.551a.694.694,0,0,0,.37.619l8.571,4.775a.746.746,0,0,0,.741,0l8.571-4.775a.694.694,0,0,0,.37-.619V23a.694.694,0,0,0-.37-.619l-2.935-1.635L58.6,25.935V29.65a.222.222,0,0,1-.333.186l-2.256-1.257a.208.208,0,0,1-.111-.186V24.431l9.311-5.188ZM51.406,29.719l-2.32,1.293v3.962a.208.208,0,0,0,.111.186l2.256,1.257a.222.222,0,0,0,.333-.186V33.664a1.913,1.913,0,0,0,.583.5L57.11,36.8v6.806l-1.648.918a.746.746,0,0,1-.741,0L46.15,39.752a.694.694,0,0,1-.37-.619V29.583a.694.694,0,0,1,.37-.619l5.256-2.928Z",
    transform: "translate(-24125.678 13548.401)",
    fill: "#86899b",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxCat1);
export default __webpack_public_path__ + "static/media/box_cat1.4ca9db1cea0895d6031f27e153abc392.svg";
export { ForwardRef as ReactComponent };